import { type CSSProperties, type FC } from "react";
import styles from "./Backdrop.module.css";

interface Props {
  onClick?: () => void;
  style?: CSSProperties;
  className?: string;
}

const Backdrop: FC<Props> = ({ onClick, className = "", style }) => {
  return (
    <div
      data-testid="modal-backdrop"
      className={`${styles.container} ${className}`}
      style={style}
      onClick={(e) => (e.stopPropagation(), onClick && onClick())}
    />
  );
};

export default Backdrop;
